var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-video-history-new__timeline-filled",style:({
    width: `${_vm.widthPercentage}%`,
    left: `${_vm.startPercentage}%`,
  })},[(_vm.hasBufferedRange)?_c('div',{staticClass:"mc-video-history-new__timeline-filled-buffered",style:(_vm.bufferedStyle)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }